'use client';

import { useEffect, useState } from 'react';

interface RobutlerLogoProps {
  className?: string;
  width?: number;
  height?: number;
}

export function RobutlerLogo({ className, width = 64, height = 64 }: RobutlerLogoProps) {
  const [isBlinking, setIsBlinking] = useState(false);

  useEffect(() => {
    const createBlinkSequence = () => {
      setIsBlinking(true);
      setTimeout(() => {
        setIsBlinking(false);
        setTimeout(() => {
          setIsBlinking(true);
          setTimeout(() => {
            setIsBlinking(false);
          }, 150);
        }, 150);
      }, 150);
    };

    const initialTimeout = setTimeout(createBlinkSequence, 1500);

    const interval = setInterval(createBlinkSequence, 4000 + Math.random() * 4000);

    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M27.468,18.902h-8.742c-.098,0-.177-.079-.177-.177s.079-.177.177-.177c2.446,0,4.753-.945,6.498-2.658,1.742-1.713,2.728-3.998,2.775-6.437.046-2.456-.896-4.794-2.652-6.585-1.788-1.823-4.271-2.869-6.807-2.869H.532C.238,0,0,.238,0,.532v26.936c0,.294.238.532.532.532h8.034c.294,0,.532-.238.532-.532v-8.743c0-.098.079-.177.177-.177s.177.079.177.177c0,5.114,4.16,9.274,9.274,9.274h8.742c.294,0,.532-.238.532-.532v-8.034c0-.294-.238-.532-.532-.532ZM9.292,11.314c-1.087,0-1.968-.881-1.968-1.968s.881-1.968,1.968-1.968,1.968.881,1.968,1.968-.881,1.968-1.968,1.968ZM16.831,9.346c0-1.087.881-1.968,1.968-1.968s1.968.881,1.968,1.968-.881,1.968-1.968,1.968-1.968-.881-1.968-1.968Z"
      />
      <circle
        cx="9.292" cy="9.346" r="1.968"
        fill="currentColor"
        style={{ opacity: isBlinking ? 1 : 0, transition: 'opacity 0.15s ease-in-out' }}
      />
      <circle
        cx="18.799" cy="9.346" r="1.968"
        fill="currentColor"
        style={{ opacity: isBlinking ? 1 : 0, transition: 'opacity 0.15s ease-in-out' }}
      />
    </svg>
  );
}
